import CONFIGURACIONES from "../../../../util/constants";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import React from "react";
import SwitchCheckbox from "../../../global/content/SwitchCheckbox";

const MantCargosAreaEmployee = ( {title, idEdit, createData, closeSection, idRef, areas, icon, showCreate, showEdit}) => {
    const { handleSubmit, reset, formState: { errors } } = useForm({mode: "onChange"});
    // const [title, setTitle] = useState(CONFIGURACIONES.INIT.STRING);

    const onSubmit1 = (form) => {
        let arrElements = [];
        areas.map(cmp => {
            cmp.cargos.map(perm => {
                let check = document.getElementById(`chk_${cmp.area.id}_${perm.id}`)
                console.log(`key: ${cmp.area.id}_${perm.id}, name: ${cmp.area.nombre}_${perm.nombre} -> ${check.checked}`);

                if (check.checked) {
                    arrElements.push({'cargoId': perm.id, 'areaId': cmp.area.id})
                }

            })
        });
        // console.log('arrElements', arrElements);
        createData(arrElements);
    };

    const loadForm = (object) => {
        // setValue('nombre', object.nombre);
        // setValue('descripcion', object.descripcion);
    };

    return (
        <>
            { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
                {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
                <div className="card-content">
                    <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                        <div className="row">
                            <div className="col-xs-12 col-md-11">
                                <h5 className="card-title font-weight-bold"><i className={`mdi ${icon}`}></i> {title}</h5>
                                <div className="row">
                                    {areas.map((cmp, index) => (
                                        <React.Fragment key={`frag_${cmp.area.id}__${index}`}>
                                            <div className="col-sm-12 col-md-12 pb-3 pt-3 border-bottom">
                                                <h4> {`Área: ${cmp.area.nombre}`}</h4>
                                                <div className="row">
                                                    {cmp.cargos.map((perm) => (
                                                        <React.Fragment key={`column_${cmp.area.id}__${perm.id}`}>
                                                            <div className="col-sm-12 col-md-3">
                                                                <SwitchCheckbox label={`${perm.nombre}`} name={`chk_${cmp.area.id}_${perm.id}`} checked={perm.estadoId == 'Y'?true:false} />
                                                            </div>
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="action-form mt-3 d-flex justify-content-start">
                            <div className="form-group mb-0 text-left">
                                <WaveButton type="button" onClick={ closeSection } className="btn btn-sm btn-outline-danger waves-effect">
                                    <i className="mdi mdi-arrow-left"></i> Descartar
                                </WaveButton>
                                { idRef == CONFIGURACIONES.INIT.ID_EDIT && showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect ml-2">
                                    <i className="mdi mdi-content-save-settings"></i> Guardar
                                </WaveButton>}

                                { idRef > CONFIGURACIONES.INIT.NUMBER && showEdit && <WaveButton type="submit" className="btn btn-sm btn-info waves-effect ml-2">
                                    <i className="mdi mdi-content-save-settings"></i> Modificar
                                </WaveButton>}
                            </div>
                        </div>
                    </form>
                </div>
            </>
            }
        </>
    )
}
export default MantCargosAreaEmployee;